<script>
    // Stores 
    import { textSite, mailLocacao, mailVendas } from '../store.js';    
    import { afterUpdate } from 'svelte';

    // Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    import Forms from "../components/Forms.svelte";  
    import PageHeader from './../components/PageHeader.svelte';

    // Code
    let titlePage = 'Anuncie seu imóvel';

    let fields = [
        {
            title:  'Nome *',
            name:   'nome',
            required:   'required'
        },
        {
            title:  'Telefone *',
            name:   'telefone',
            required: 'required',
            classe:   'mask-telefone'
        },
        {
            title:  'Email *',
            name:   'email',
            type:   'email',
            required: 'required',
        },
        {
            title:  'Interesse *',
            name:   'interesse',
            required: 'required',
            type:   'select',
            selectValues : [
                {title : 'Alugar meu Imóvel', value: 'Alugar meu Imóvel'},
                {title : 'Vender meu Imóvel', value: 'Vender meu Imóvel'},
                {title : 'Vender ou Alugar meu imóvel', value: 'Vender ou Alugar meu imóvel'}
            ],
        },   
        {
            title:  'Tipo do Imóvel *',
            name:   'imovel-tipo',
            required: 'required',
            type:   'select',
            selectValues : [
                {title : 'Tipo do Imóvel', value: ''},
                {title : 'Apartamento', value: 'Apartamento'},
                {title : 'Cobertura', value: 'Cobertura'},
                {title : 'Casa Residencial', value: 'Casa Residencial'},
                {title : 'Loja', value: 'Loja'},
                {title : 'Sala/Conjunto', value: 'Sala/Conjunto'},
                {title : 'Pavilhão/depósito', value: 'Pavilhão/depósito'},
                {title : 'Terreno', value: 'Terreno'},
                {title : 'Outros', value: 'Outros'}
            ],
        },   
        {
            title:  'Endereço do Imóvel *',
            name:   'imovel-endereco',
            required: 'required',
        },        {
            title:  'Bairro *',
            name:   'bairro',
            required: 'required',
        },        
        {
            title:  'Cidade *',
            name:   'cidade',
            required: 'required',
        },
        {
            title:  'Área Total (m²) *',
            name:   'imovel-area-total',
            classe: 'mask-number',
        },
        {
            title:  'Área Privada (m²) *',
            name:   'imovel-area-privada',
            classe: 'mask-number',
        },
        {
            title:  'Número de Dormitórios',
            name:   'imovel-dormitorios',
            classe: 'mask-number',
        },
        {
            title:  'Número de Banheiros',
            name:   'imovel-banheiros',
            classe: 'mask-number',
        },
        {
            title:  'Número de Vagas',
            name:   'imovel-vagas',
            classe: 'mask-number',
        },
        {
            title:  'Mobiliado?',
            name: 'imovel-mobiliado',
            type: 'select',
            selectValues : [
                {title : 'Não', value: 'Não'},
                {title : 'Sim', value: 'Sim'}
            ],
        },         
    ];

    const message = `
Nome: {nome}
Telefone: {telefone}
Email: {email}
Interesse: {interesse}
Tipo do Imóvel: {imovel-tipo}
Endereço do Imóvel: {imovel-endereco}
Bairro: {bairro}
Cidade: {cidade}
Área Total (m²): {imovel-area-total}
Área Privada (m²): {imovel-area-privada}
Número de Dormitórios: {imovel-dormitorios}
Número de Banheiros: {imovel-banheiros}
Número de Vagas: {imovel-vagas}
Mobiliado? {imovel-mobiliado}

{info}
    `;

    let loading = false;

    function send() {
        loading = true;
    }
   
    let destiny = $mailLocacao;

    afterUpdate(() => {
        try{
            /* Alteração destino conforme interesse */
            let queryInteresse = document.querySelector('#interesse');
    
            queryInteresse.addEventListener("change", function(){
                let interesse = queryInteresse.value;
                destiny = interesse == "Vender meu Imóvel" ? $mailVendas : $mailLocacao;    
            });
        }catch(ex) { 

        } 
    });

</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container">
        <p class="text-center">
			Quer deixar seu imóvel para alugar ou vender? Anuncie com a gente, nós cuidamos de tudo para você.
        </p>
        <p class="text-center">
			Envie os dados do seu imóvel, preenchendo o formulário abaixo.      
        </p>
        <div class="offset-md-3 col-md-6 pl-0 pr-0">       
            <hr class="line-separator">
            <Forms fields={fields} destiny={destiny} subjectTitle="{titlePage}" {message} htmlbody={false} />
        </div>
    </div>
</section>